import React, { useState, useEffect } from 'react';

let TIMEOUT = null;

function Search(props) {
    
    const { searchFinish, clear } = props;
    
    const [search, setSearch] = useState("");

    useEffect(() => {
        clearTimeout(TIMEOUT);
        if(search && search.length > 0){
            TIMEOUT = setTimeout(function(){
                searchFinish(search);
            }.bind(this), 900);
        }else{
            clear("");
        }
        
        return () => clearTimeout(TIMEOUT);
    },[search]);

    return (
        <input type="search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder='Buscar'/>
    );
}
    
export default Search;
